import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import Home from './component/Pages/Home/Home';
import Footer from './component/Footer/Footer';
import { history } from './component/helpers/history';
import { PrivateRoute } from './component/helpers/PrivateRoute';
import Common from './component/Pages/Common';
import BetSlip from './component/Pages/BetSlip';
import Result from './component/Pages/Result';
import GeneralInfo from './component/Pages/GeneralInfo/GeneralInfo';
import ErrorBoundary from './component/Error';
import Login from './component/Login';
import Otpgeneration from './component/Otpgeneration';
import Register from './component/Register';
import Lotto from './component/Pages/Games/Lotto';
import MyCart from './component/Pages/MyCart';
import Payment from './component/Pages/Payment';
import PaymentVerify from './component/Pages/PaymentVerify';
import PaymentStatus from './component/Pages/PaymentStatus';
import Faqs from './component/Pages/GeneralInfo/Faqs';
import Account from './component/Pages/MyAccount/Account';
import Mydraws from './component/Pages/Draw/Mydraws';
import HowToPlayPage from './component/Pages/GeneralInfo/HowToPlayPage';
import UnderConstruction from './component/Pages/GeneralInfo/UnderConstruction';
import { commonClass } from './component/helpers/commonClass';
import { withTranslation } from 'react-i18next';
import OtpForgetPassword from './component/OtpForgetPassword';
import ForgetPassword from './component/ForgetPassword';
import Promotion from './component/Pages/GeneralInfo/Promotion';
import PromotionRules from './component/Pages/GeneralInfo/PromotionRules';
import RegisterActivation from './component/RegisterActivation';
import TermsCondition from './component/Pages/GeneralInfo/TermsCondition';
import Viewdetailedresults from './component/Pages/Draw/Viewdetailedresults';
import PageNotFound from './component/Pages/404';
import Promotionterms from './component/Pages/GeneralInfo/Promotionterms';
import { Helmet } from "react-helmet";
import { helmetJsonLdProp } from "react-schemaorg";
import SetCookie from './component/Cookie/SetCookie';
import ContactUs from './component/Pages/GeneralInfo/ContactUs';
import WinnersStory from './component/Pages/Draw/WinnersStory';
import Feedback from './component/Pages/GeneralInfo/Feedback';
import PrivacyPolicyPage from './component/Pages/GeneralInfo/PrivacyPolicyPage';
import OfferSuper6 from './component/Pages/GeneralInfo/OfferSuper6';
import OfferFortune6 from './component/Pages/GeneralInfo/OfferFortune6';
import Promotionwithcdn from './component/Pages/GeneralInfo/Promotionwithcdn';
import RouteRedirect from './RouteRedirect';
import BuyJackpotOnlineMY from './component/blogs/Malaysian/BuyJackpotOnline';
import JackpotLoterryMy from './component/blogs/Malaysian/JackpotLottery';
import LottoWinningNumbersMy from './component/blogs/Malaysian/LottoWinningNumbers';
import JackpotWinnerTodayMy from './component/blogs/Malaysian/JackpotWinnerToday';
import BigLotteryJackpotMy from './component/blogs/Malaysian/BigLotteryJackpot';
import TotoOnlineBetMy from './component/blogs/Malaysian/TotoOnlineBet';
import BigTicketLiveTodayMy from './component/blogs/Malaysian/BigTicketLiveToday';
import BuyBigticketOnlineMy from './component/blogs/Malaysian/BuyBigticketOnline';
import BigTicketLiveMy from './component/blogs/Malaysian/BigTicketLive';
import BuyJackpotOnline from './component/blogs/Indian/BuyJackpotOnline';
import JackpotLottery from './component/blogs/Indian/JackpotLottery';
import LotteryWinningNumbers from './component/blogs/Indian/LotteryWinningNumbers';
import JackpotWinnerToday from './component/blogs/Indian/JackpotWinnerToday';
import BigLotteryJackpot from './component/blogs/Indian/BigLotteryJackpot';
import LotteryOnlineBet from './component/blogs/Indian/LotteryOnlineBet';
import LotteryTicketLive from './component/blogs/Indian/LotteryTicketLive';
import BuyLotteryTicketOnline from './component/blogs/Indian/BuyLotteryTicketOnline';
import LotteryTicketliveToday from './component/blogs/Indian/LotteryTicketLiveToday';
import Instant from './component/Pages/Games/Instant';
import SlotGame from './component/Pages/Games/SlotGame';
import LoginNew from './component/LoginNew';
import Header from './component/Header/Header';
import RegisterThankYou from './component/RegisterThankYou';
import Roulette from './component/Pages/Roulette/RouletteIndex';
import PaymentStatusNew from './component/Pages/PaymentStatusNew';
import PlyerKYCpage from './component/Pages/GeneralInfo/PlyerKYCpage';
import SupportMatrix from './component/Pages/GeneralInfo/SupportMatrix';
import RouletteInstant from './component/Pages/RouletteInstant/RouletteIndex';
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locadet: window.location.pathname.split('/')[window.location.pathname.split('/').length - 1].toLowerCase()
    }
    history.listen((location, action) => {
      console.log("New version is : " + process.env.REACT_APP_Version);
      console.log("New version is : " + location.path);
    });
    let _myapp = JSON.parse(localStorage.getItem('appvariables'));
    if (_myapp && process.env.REACT_APP_Version != _myapp.version) {
      let Cvalue = commonClass.SetCountryCode();
      localStorage.setItem('appvariables', JSON.stringify({ countryCode: "", currency: Cvalue, version: process.env.REACT_APP_Version, bVersion: _myapp.bVersion }));//bVersion: _myapp.bVersion
      // window.location.href = window.location.href;
      // window.location.replace(window.location.href);
      window.location.reload(true);
    }
    if (_myapp == null || _myapp == undefined) {
      let Cvalue = commonClass.SetCountryCode();
      // 0 => get banner ,1 => our winners image.,2 => Promotion ,3 => PastDraw Shows(Utube Video Upload),4 => (Winner Story Youtube Url,Celebrities),5 => Get NewsLetter Json,6 => OfferImage Show Page 
      localStorage.setItem('appvariables', JSON.stringify({ countryCode: process.env.REACT_APP_Countrycode, currency: Cvalue, version: process.env.REACT_APP_Version, bVersion: "0~0~0~0~0~0~0" })); //bVersion: "0~0~0~0"
    }
    let _user = localStorage.getItem('user');
    if (_user == null || _user == undefined) {
      //this.props.loginSkip(1);
      let userdata = { userid: "0", username: "", mobileNo: "0", balance: "0", winbalance: "0", bonus: "0", withdrawbalance: '0', loginKey: "0", emailID: "", loginExpiry: 0, Imageinfo: " ", Created_date: "", Player_name: "", Country_code: process.env.REACT_APP_Countrycode, kycstatus: "0", bonuswinning: '0', freecount: '0', Usertoken: '0' };
      localStorage.setItem('user', commonClass.encrypt(JSON.stringify(userdata)));
    }
    //window.loadscriptLacy(); //implement in index.html file.
  }

  componentDidMount() {
    // let IsLanguage = localStorage.getItem('cloc');
    // if (IsLanguage == null) {
    //   alert('Checkurl')
    //   window.location.href = "/";
    // }
    // let myloc = history.location.pathname;
    let myloc = history.location.pathname + history.location.search;
    commonClass.SendPageEvent(myloc);
    commonClass.SendFacebookpixel();
    commonClass.SendEventTracking(20, {});
    try {
      const queryParameters = new URLSearchParams(window.location.search)
      const type = queryParameters.get("cid")
      if (type) {
        localStorage.setItem('ipcountry', type)
        setTimeout(() => {
          history.push('/register')
        }, 500);
      }
      const _type = queryParameters.get("agrid")
      const _type1 = queryParameters.get("plyrid")
      const _type2 = queryParameters.get("champage_id")
      if (_type || _type1 || _type2) {
        if (_type) {
          localStorage.setItem('agentid', _type)
        }
        else if (_type1) {
          sessionStorage.setItem('plyrid', _type1)
        }
        else if (_type2) {
          localStorage.setItem('cham_id', _type2)
        }
        if (this.state.locadet.toLowerCase() != 'register') {
          setTimeout(() => {
            history.push('/register')
          }, 500);
        }
      }
    } catch (error) {

    }
    // var _c = new Date().getTime();
    // const script = document.createElement("script");
    // script.src = "https://trk.convserv.com/tracko/v1/cont/cont.js?of=330&ac=7&af=20&cs=0&ts={" + _c + "}";
    // script.async = true;
    // document.body.appendChild(script);
  }
  render() {
    return (
      <>
        {process.env.REACT_APP_MODE != "development" && <Helmet

        // script={[
        //   helmetJsonLdProp({
        //     "@context": "http://www.schema.org",
        //     "@type": "WebSite",
        //     name: "Gulf Ticket ",
        //     alternateName: "Gulf Ticket India",
        //     url: "https://gulfticket.com/"
        //   }),
        // ]}
        >
          {/* <link rel="canonical" href="https://gulfticket.com/" /> */}
          <link rel="canonical" href={window.location.href} />
          <meta name="google-site-verification" content="6rb-DK-9U641DxLR8qJzqkkXq5fJcpAOl68exvxO7hs" />
        </Helmet>}
        {/* <div dir={this.props.i18n.language == 'ar' || this.props.i18n.language == 'ur' ? "rtl" : "ltr"} lang={this.props.i18n.language == 'ar' ? "ar" : "en"} className="mainContainer"> */}
        <div className={`mainContainer ${this.state.locadet == 'paymentstatus'  ? '' : 'bg3'}`}>
          <ErrorBoundary>
            <Router basename={process.env.REACT_APP_BASENAME} history={history}>
              <Common />
              <BetSlip />
              {/* <SetCookie launguage={this.props} /> */}
              <Switch>
                <Route exact path="/" component={RouteRedirect} />

                {/* <PrivateRoute exact path="/" component={Home} /> */}
                <Route exact path='/home' component={Home} />
                {/* <Route exact path='/fortune4' render={() => <Lotto lottotype="9" />} />
                <Route exact path='/super6' render={() => <Lotto lottotype="10" />} />
                <Route exact path='/magic5' render={() => <Lotto lottotype="11" />} />
                <Route exact path='/lucky1' render={() => <Lotto lottotype="13" />} /> */}

                <Route exact path='/playlotto' render={() => <Lotto lottotype="1" />} />
                <Route exact path='/minilotto' render={() => <Lotto lottotype="2" />} />
                <Route exact path='/fastlotto' render={() => <Lotto lottotype="3" />} />
                <Route exact path='/millionairelotto' render={() => <Lotto lottotype="4" />} />
                <Route exact path='/multimillion' render={() => <Lotto lottotype="5" />} />
                <Route exact path='/supermega' render={() => <Lotto lottotype="6" />} />

                {/* <Route exact path='/Result' component={Result} /> */}
                <Route exact path='/generalinfo' component={GeneralInfo} />
                <Route exact path='/login' component={Login} />
                <Route exact path='/loginnew' component={Header} />
                <Route exact path='/Otpgeneration' component={Otpgeneration} />
                <Route exact path='/register' component={Register} />
                <Route exact path='/mycart' component={Payment} />  {/* MyCart */}
                <Route exact path='/payment' component={Payment} />
                <Route exact path='/paymentverify' component={PaymentVerify} />
                <Route exact path='/slotgame' component={SlotGame} />
                <Route exact path='/paymentstatus' component={PaymentStatusNew} />
                {/* <Route exact path='/promotion' component={GeneralInfo} /> */}
                <Route exact path='/faqs' component={Faqs} />
                <Route exact path='/HowtoPlay' component={HowToPlayPage} />
                <Route exact path='/Account' component={Account} />
                <Route exact path='/UnderConstruction' component={UnderConstruction} />


                <Route exact path='/playlottodraws' render={() => <Mydraws drawtype="1" />} />
                <Route exact path='/minilottodraws' render={() => <Mydraws drawtype="2" />} />
                <Route exact path='/fastlottodraws' render={() => <Mydraws drawtype="3" />} />
                <Route exact path='/millionairelottodraws' render={() => <Mydraws drawtype="4" />} />
                <Route exact path='/multimilliondraws' render={() => <Mydraws drawtype="5" />} />
                <Route exact path='/supermegadraws' render={() => <Mydraws drawtype="6" />} />

              

                <Route exact path='/OtpForgetPassword' component={OtpForgetPassword} />
                <Route exact path='/ForgetPassword' component={ForgetPassword} />
                <Route exact path='/promotion' component={Promotion} />
                {/* <Route exact path='/promotion' component={Promotionwithcdn} /> */}
                <Route exact path='/PromotionRules' component={PromotionRules} />
                <Route exact path='/Instant' component={Instant} />
                <Route exact path='/allroulette' component={Instant} />
                <Route exact path='/registerActivation' component={RegisterActivation} />
                <Route exact path='/registerThankYou' component={RegisterThankYou} />
                <Route exact path='/termscondition' component={TermsCondition} />
                <Route exact path="/Viewdetailedresults" component={Viewdetailedresults} />
                <Route exact path="/promotionterms" component={Promotionterms} />
                <Route exact path="/Contactus" component={ContactUs} />
                <Route exact path="/winnersstory" component={WinnersStory} />
                <Route exact path="/feedback" component={Feedback} />
                <Route exact path="/Reload" component={PageNotFound} />
                <Route exact path="/404" component={PageNotFound} />
                {/* <Route exact path="/*" component={PageNotFound} /> */}
                <Route exact path="/Privacy" component={PrivacyPolicyPage} />
                <Route exact path="/OfferSuper6" component={OfferSuper6} />
                <Route exact path="/Offerfortune6" component={OfferFortune6} />
                <Route exact path='/roulette' component={Roulette} />
                <Route exact path='/SupportMatrix' component={SupportMatrix} />

                <Route exact path='/rouletteInstant' component={RouletteInstant} />
                

                {/* Add Language For Routing */}
                <PrivateRoute exact path="/:language/" component={Home} />
                <PrivateRoute exact path="/:language/lottery-ticket" component={Home} />
                <PrivateRoute exact path="/:language/big-ticket" component={Home} />
                <PrivateRoute exact path="/:language/home" component={Home} />
                <PrivateRoute exact path="/:language/lotto" component={Lotto} />
                <Route exact path='/:language/SupportMatrix' component={SupportMatrix} />



                <Route exact path="/:language/playlotto" render={() => <Lotto lottotype="1" />} />
                <Route exact path="/:language/minilotto" render={() => <Lotto lottotype="2" />} />
                <Route exact path="/:language/fastlotto" render={() => <Lotto lottotype="3" />} />
                <Route exact path="/:language/millionairelotto" render={() => <Lotto lottotype="4" />} />
                <Route exact path="/:language/multimillion" render={() => <Lotto lottotype="5" />} />
                <Route exact path="/:language/supermega" render={() => <Lotto lottotype="6" />} />

                {/* Other Countries */}
                <Route exact path="/:language/loginnew" component={LoginNew} />
                <Route exact path="/:language/lottery-ticket/playlotto" render={() => <Home lottotype="1" />} />
                <Route exact path="/:language/lottery-ticket/minilotto" render={() => <Home lottotype="2" />} />
                <Route exact path="/:language/lottery-ticket/fastlotto" render={() => <Home lottotype="3" />} />
                <Route exact path="/:language/lottery-ticket/millionairelotto" render={() => <Home lottotype="4" />} />
                <Route exact path="/:language/lottery-ticket/multimillion" render={() => <Home lottotype="5" />} />
                <Route exact path="/:language/lottery-ticket/supermega" render={() => <Home lottotype="6" />} />

                {/* Other Countries */}
                <Route exact path="/:language/big-ticket/playlotto" render={() => <Home lottotype="1" />} />
                <Route exact path="/:language/big-ticket/minilotto" render={() => <Home lottotype="2" />} />
                <Route exact path="/:language/big-ticket/fastlotto" render={() => <Home lottotype="3" />} />
                <Route exact path="/:language/big-ticket/millionairelotto" render={() => <Home lottotype="4" />} />
                <Route exact path="/:language/big-ticket/multimillion" render={() => <Home lottotype="5" />} />
                <Route exact path="/:language/big-ticket/supermega" render={() => <Home lottotype="6" />} />

                {/* Only Malasiya */}
                <Route exact path="/:language/lottery-ticket/fortune6-6d" render={() => <Home lottotype="1" />} />
                <Route exact path="/:language/lottery-ticket/super6-6d" render={() => <Home lottotype="2" />} />
                <Route exact path="/:language/lottery-ticket/magic5-5d" render={() => <Home lottotype="3" />} />
                <Route exact path="/:language/lottery-ticket/lucky1-1d" render={() => <Home lottotype="4" />} />
                <Route exact path="/:language/lottery-ticket/dream5-5d" render={() => <Home lottotype="5" />} />
                <Route exact path="/:language/lottery-ticket/rush3-3d" render={() => <Home lottotype="6" />} />

                <Route exact path="/:language/generalinfo" component={GeneralInfo} />
                <Route exact path="/:language/login" component={Login} />
                <Route exact path="/:language/Otpgeneration" component={Otpgeneration} />
                <Route exact path="/:language/register" component={Register} />
                <Route exact path="/:language/mycart" component={Payment} /> {/* MyCart */}
                <Route exact path="/:language/payment" component={Payment} />
                <Route exact path="/:language/paymentverify" component={PaymentVerify} />
                <Route exact path="/:language/paymentstatus" component={PaymentStatusNew} />
                <Route exact path="/:language/faqs" component={Faqs} />
                <Route exact path="/:language/HowtoPlay" component={HowToPlayPage} />
                <Route exact path="/:language/Account" component={Account} />
                <Route exact path="/:language/UnderConstruction" component={UnderConstruction} />
                <Route exact path='/:language/Instant' component={Instant} />
                <Route exact path='/:language/allroulette' component={Instant} />
                <Route exact path='/:language/slotgame' component={SlotGame} />
                <Route exact path='/:language/bonus-details' component={BuyJackpotOnlineMY} />
                <Route exact path='/:language/bonus-details-separate' component={BuyJackpotOnlineMY} />
                {/* Normal  */}


                <Route exact path="/:language/playlottodraws" render={() => <Mydraws drawtype="1" />} />
                <Route exact path="/:language/minilottodraws" render={() => <Mydraws drawtype="2" />} />
                <Route exact path="/:language/fastlottodraws" render={() => <Mydraws drawtype="3" />} />
                <Route exact path="/:language/millionairelottodraws" render={() => <Mydraws drawtype="4" />} />
                <Route exact path="/:language/multimilliondraws" render={() => <Mydraws drawtype="5" />} />
                <Route exact path="/:language/supermegadraws" render={() => <Mydraws drawtype="6" />} />

                {/* Other Countries */}
                <Route exact path="/:language/live-results-playlottodraws" render={() => <Mydraws drawtype="1" />} />
                <Route exact path="/:language/live-results-minilottodraws" render={() => <Mydraws drawtype="2" />} />
                <Route exact path="/:language/live-results-fastlottodraws" render={() => <Mydraws drawtype="3" />} />
                <Route exact path="/:language/live-results-millionairelottodraws" render={() => <Mydraws drawtype="4" />} />
                <Route exact path="/:language/live-results-multimilliondraws" render={() => <Mydraws drawtype="5" />} />
                <Route exact path="/:language/live-results-supermegadraws" render={() => <Mydraws drawtype="6" />} />
                <Route exact path="/:language/live-results-promotion" component={Promotion} />

                {/* Malasiya */}
                <Route exact path="/:language/6d-live-results-playlottodraws" render={() => <Mydraws drawtype="1" />} />
                <Route exact path="/:language/6d-live-results-minilottodraws" render={() => <Mydraws drawtype="2" />} />
                <Route exact path="/:language/5d-live-results-fastlottodraws" render={() => <Mydraws drawtype="3" />} />
                <Route exact path="/:language/1d-live-results-millionairelottodraws" render={() => <Mydraws drawtype="4" />} />
                <Route exact path="/:language/5d-live-results-multimilliondraws" render={() => <Mydraws drawtype="5" />} />
                <Route exact path="/:language/3d-live-results-supermegadraws" render={() => <Mydraws drawtype="6" />} />

                <Route exact path="/:language/OtpForgetPassword" component={OtpForgetPassword} />
                <Route exact path="/:language/ForgetPassword" component={ForgetPassword} />
                <Route exact path="/:language/promotion" component={Promotion} />
                <Route exact path="/:language/PromotionRules" component={PromotionRules} />
                <Route exact path="/:language/registerActivation" component={RegisterActivation} />
                <Route exact path='/:language/registerThankYou' component={RegisterThankYou} />
                <Route exact path="/:language/termscondition" component={TermsCondition} />
                <Route exact path="/:language/Viewdetailedresults" component={Viewdetailedresults} />
                <Route exact path="/:language/promotionterms" component={Promotionterms} />
                <Route exact path="/:language/Contactus" component={ContactUs} />
                <Route exact path="/:language/winnersstory" component={WinnersStory} />
                <Route exact path="/:language/feedback" component={Feedback} />
                <Route exact path="/:language/Reload" component={PageNotFound} />
                <Route exact path="/:language/404" component={PageNotFound} />
                <Route exact path="/:language/Privacy" component={PrivacyPolicyPage} />
                <Route exact path="/:language/OfferSuper6" component={OfferSuper6} />
                <Route exact path="/:language/Offerfortune6" component={OfferFortune6} />
                <Route exact path='/:language/plyerkyc' component={PlyerKYCpage} />  

                {/*Malasiya Content blog*/}
                <Route exact path='/:language/lottery-ticket/buy-jackpot-online' component={BuyJackpotOnlineMY} />
                <Route exact path='/:language/lottery-ticket/jackpot-Loterry' component={JackpotLoterryMy} />
                <Route exact path='/:language/lottery-ticket/lotto-winning-numbers' component={LottoWinningNumbersMy} />
                <Route exact path='/:language/lottery-ticket/jackpot-winner-today' component={JackpotWinnerTodayMy} />
                <Route exact path='/:language/lottery-ticket/big-Loterry-jackpot' component={BigLotteryJackpotMy} />
                <Route exact path='/:language/lottery-ticket/toto-online-bet' component={TotoOnlineBetMy} />
                <Route exact path="/:language/live/big-ticket-live" component={BigTicketLiveMy} />
                <Route exact path="/:language/purchase/buy-big-ticket-online" component={BuyBigticketOnlineMy} />
                <Route exact path="/:language/games/big-ticket-live-today" component={BigTicketLiveTodayMy} />

                {/*Indian Content blog*/}

                <Route exact path='/:language/big-ticket/buy-jackpot-online' component={BuyJackpotOnline} />
                <Route exact path='/:language/big-ticket/jackpot-lottery' component={JackpotLottery} />
                <Route exact path='/:language/big-ticket/lottery-winning-numbers' component={LotteryWinningNumbers} />
                <Route exact path='/:language/big-ticket/jackpot-winner-today' component={JackpotWinnerToday} />
                <Route exact path='/:language/big-ticket/big-lottery-jackpot' component={BigLotteryJackpot} />
                <Route exact path='/:language/big-ticket/lottery-online-bet' component={LotteryOnlineBet} />
                <Route exact path="/:language/live/lottery-ticket-live" component={LotteryTicketLive} />
                <Route exact path="/:language/purchase/buy-lottery-ticket-online" component={BuyLotteryTicketOnline} />
                <Route exact path="/:language/games/lottery-ticket-live-today" component={LotteryTicketliveToday} />
                <Route exact path='/:language/roulette' component={Roulette} />
                <Route exact path='/:language/rouletteInstant' component={RouletteInstant} />                

                {/* Redirect all unmatched routes to the 404 page */}
                <Route exact path="/*" render={() => <Redirect to="/:language/404" />} />
                <Route exact path="/*" render={() => <Redirect to='/404' />} />
                {/* Old One */}

              </Switch>
            </Router>
          </ErrorBoundary>
        </div>
        {/* {(this.state.locadet == 'register') ?
          <Footer /> : <></>
        } */}
      </>
    );
  }
}
//export default App;
export default withTranslation()(App)